/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SubscriptionPayment from './subscription-payment';
import SubscriptionPaymentDetail from './subscription-payment-detail';
import SubscriptionPaymentUpdate from './subscription-payment-update';
import SubscriptionPaymentDeleteDialog from './subscription-payment-delete-dialog';

const SubscriptionPaymentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SubscriptionPayment />} />
    <Route path="new" element={<SubscriptionPaymentUpdate />} />
    <Route path=":id">
      <Route index element={<SubscriptionPaymentDetail />} />
      <Route path="edit" element={<SubscriptionPaymentUpdate />} />
      <Route path="delete" element={<SubscriptionPaymentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SubscriptionPaymentRoutes;
